import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect from '../../componentes/formulario/MiSelect';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { getTitle, getDecodedCookie } from '../../helpers/helperApp';

import { Fragment } from 'react';

function ClaAge(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, saveFormularioHijo , handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin, handleSubmitPrin, resetFormPrin, handleSelectFormPrin } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{   
                    document.title = getTitle(confPantalla.config.trad, confPantalla.claage.title);                                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true); 
                        saveEstadoFormPrin(confPantalla.claage.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.claage.hijo.estadoform);                              
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.claage.padre.urls);
                                saveFormularioPrin(confPantalla.claage.padre.modelform);
                                saveFormularioHijo(confPantalla.claage.hijo.modelform);     
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.claage.padre.urls, confPantalla.claage.hijo.urls, confPantalla.claage.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);    
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])
 

    return(
        <div className="App wrapper">
             <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>    
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.claage.section.titulo } icono={ confPantalla.claage.section.icono } col={ confPantalla.claage.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.claage.section.wiki } >
                            <Formulario 
                                        estadoForm= { estadoFormPrin }
                                        loading=    { loadReg ? true : false }
                                        btnNew={ confPantalla.claage.padre.btnform.new }
                                        btnSave={ confPantalla.claage.padre.btnform.save }
                                        btnSaveAndNew={ confPantalla.claage.padre.btnform.saveandnew }
                                        btnDelete={ confPantalla.claage.padre.btnform.delete }
                                        btnClone={ confPantalla.claage.padre.btnform.clone }
                                        handleSubmit = { e => handleSubmitPrin(e, confPantalla.claage.padre.urls, confPantalla.claage.padre.modelform, confPantalla.claage.padre.tabla, confPantalla.claage.hijo.modelform, confPantalla.claage.title) }  
                                        formulario = { formularioPrin } 
                                        resetForm = { e => resetFormPrin(confPantalla.claage.padre.modelform, true, confPantalla.claage.padre.tabla) } 
                                        handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.claage.padre.urls, confPantalla.claage.padre.modelform, confPantalla.claage.padre.tabla, confPantalla.claage.title) } 
                            >         
                                <FormRow clases="" >
                                {/* <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.pad  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.claage.padre.controles.pad.id }    
                                        name=        { confPantalla.claage.padre.controles.pad.name }   
                                        label=       { confPantalla.claage.padre.controles.pad.label }    
                                        placeholder= { confPantalla.claage.padre.controles.pad.placeholder }
                                        col=         { confPantalla.claage.padre.controles.pad.col } 
                                        isClearable= { confPantalla.claage.padre.controles.pad.isclearable }
                                        isSearchable={ confPantalla.claage.padre.controles.pad.issearchable }
                                        dataType=    { confPantalla.claage.padre.controles.pad.datatype }
                                        data=        { confPantalla.claage.padre.controles.pad.data }
                                        required=    { confPantalla.claage.padre.controles.pad.required } 
                                        disabled=    { confPantalla.claage.padre.controles.pad.disabled }
                                        readOnly =   { confPantalla.claage.padre.controles.pad.readonly }
                                        disablethisid={confPantalla.claage.padre.controles.pad.disablethisid}
                                        formulario = { formularioPrin } 
                                        change=      { handleSelectFormPrin }                                                    
                                    />                                                                         */}
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.claage.padre.controles.nom.id }   
                                        type=       { confPantalla.claage.padre.controles.nom.type }  
                                        name=       { confPantalla.claage.padre.controles.nom.name }   
                                        label=      { confPantalla.claage.padre.controles.nom.label }                                                       
                                        placeholder={ confPantalla.claage.padre.controles.nom.placeholder }    
                                        col=        { confPantalla.claage.padre.controles.nom.col } 
                                        required=   { confPantalla.claage.padre.controles.nom.required }
                                        readonly=   { confPantalla.claage.padre.controles.nom.readonly }                                                
                                        disabled=   { confPantalla.claage.padre.controles.nom.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                </FormRow>                            
                            </Formulario>                        
                            <MiDataTable
                                formulario={formularioPrin}  
                                estadoForm= { estadoFormPrin }
                                id={"claage"}
                                columnas={confPantalla.claage.padre.datatable.columns}
                                data={registrosPrin}
                                buttons={confPantalla.claage.padre.datatable.buttons}
                                ordering={confPantalla.claage.padre.datatable.ordering}
                                order={confPantalla.claage.padre.datatable.order}
                                searching={confPantalla.claage.padre.datatable.searching}
                                paging={confPantalla.claage.padre.datatable.paging}
                                select={confPantalla.claage.padre.datatable.select}
                                pagelength={confPantalla.claage.padre.datatable.pagelength}
                                handleEditReg= { e => handleEditRegPrin(e, confPantalla.claage.padre.urls, confPantalla.claage.hijo.urls, confPantalla.claage.padreshijos, confPantalla.claage.hijo.modelform, confPantalla.claage.padre.tabla) }
                                handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.claage.padre.urls, confPantalla.claage.padre.modelform, confPantalla.claage.padre.tabla, confPantalla.claage.title) }
                                saveLoadingTable={ saveLoadingTable }
                                loadingTable={loadingTable}
                                columnactions={confPantalla.claage.padre.datatable.columnactions.title}
                                traduction={confPantalla.config.trad.components.datatable}
                            />                                                                                                             
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default ClaAge